import React from 'react';
import { Blurb, BlurbShape } from './blurb';

interface IProps {
  blurbList: BlurbShape[];
}

export const BlurbBlocks: React.FC<IProps> = ({ blurbList }) => (
  <div className='mb-16 flex flex-col gap-6 text-neutral-800 md:flex-row md:gap-8 lg:gap-10'>
    {blurbList.map((blurb) => (
      <Blurb key={blurb.key} content={blurb} />
    ))}
  </div>
);
